import { render, staticRenderFns } from "./ImagesForm.vue?vue&type=template&id=1f0f4c8a&scoped=true&"
import script from "./ImagesForm.vue?vue&type=script&lang=js&"
export * from "./ImagesForm.vue?vue&type=script&lang=js&"
import style0 from "./ImagesForm.vue?vue&type=style&index=0&id=1f0f4c8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0f4c8a",
  null
  
)

export default component.exports